/* src/app/components/billing/ignored-timesheets/ignored-timesheets-summary/ignored-timesheets-summary.component.css */
/*# sourceMappingURL=ignored-timesheets-summary.component-R45PE72J.css.map */
